<template>
  <main>
    <Banner /> 
    <WhyUs />
    <SubBanner />
    <KeyProduct />
    <Featured />
  </main>
</template>

<script>
import Banner from './_banner'
import WhyUs from './why-us';
import SubBanner from './_sub_banner.vue'
import KeyProduct from './key-product'
import Featured from './_featured'


export default {
  components: {
    Banner,
    WhyUs,
    Featured,
    SubBanner,
    KeyProduct
  },
  data() {
    return {
      
    }
  },
}
</script>

<style lang="scss">
  .content-section{
    padding: 55px 0;

    &-title {
      position: relative;
      margin-bottom: 50px;
      color: $color-main;
      font-weight: 400;
      text-align: center;
      font-size: 36px !important;

      &.center {
        text-align: center;
        &::after {
          transform: translateX(50%);
        }
      }
    }
  }
</style>